import {
	DocumentData,
	Firestore,
	collection,
	documentId,
	getDocs,
	query,
	where,
} from "@angular/fire/firestore";

/** Firestore's ceiling on values in a single `in` clause. */
const IN_QUERY_LIMIT = 30;

/**
 * Read many documents from one collection by id, in as few round trips as
 * Firestore allows: one `in` query per thirty ids rather than one getDoc per
 * id. Returns a map keyed by id; ids with no document are simply absent, so a
 * caller that needs "was it there" checks the map rather than a null.
 */
export async function fetchDocsByIds(
	firestore: Firestore,
	collectionName: string,
	ids: readonly string[],
): Promise<Map<string, DocumentData>> {
	const result = new Map<string, DocumentData>();
	const unique = Array.from(new Set(ids));
	if (unique.length === 0) {
		return result;
	}

	const ref = collection(firestore, collectionName);
	const chunks: string[][] = [];
	for (let i = 0; i < unique.length; i += IN_QUERY_LIMIT) {
		chunks.push(unique.slice(i, i + IN_QUERY_LIMIT));
	}

	const snapshots = await Promise.all(
		chunks.map((chunk) => getDocs(query(ref, where(documentId(), "in", chunk)))),
	);
	for (const snapshot of snapshots) {
		for (const snap of snapshot.docs) {
			result.set(snap.id, snap.data());
		}
	}
	return result;
}
